import EChartCommon, {
  getAxisPointer,
} from '@/pages/opinion/components/EChartCommon';
import React, { useMemo } from 'react';
import usePcConsoleTimelineChart from '../../hooks/usePcConsoleTimelineChart';
import {
  formatTimeXAxisText,
  getChartPosition,
  setIntervalValue,
} from '@/pages/opinion/utils/chart';
import { echartsContent } from '@/pages/opinion/utils';
import {
  formatChartParamsDate,
  listTimeTitleFunc,
} from '@/pages/opinion/components/ChartCommon/formatter';
import { useIntl } from 'umi';
import { NO_DATE } from '@/pages/opinion/constants';
import { reviewsFormat } from '@/pages/opinion/utils/value';
const seriesDataKeys = [
  {
    text: 'Metascore',
    key: 'meta_score',
    type: 'line',
    color: '#5086F3',
    valueKey: 'score',
  },
  {
    text: 'User Score',
    key: 'user_score',
    type: 'line',
    color: '#69D19C',
    valueKey: 'score',
  },
];
export default function OpenCriticScoreTrendBox({
  filterParams,
  platformData,
  height = 260,
}: any) {
  const { chartMap, chartNoDataMap } = usePcConsoleTimelineChart({
    platformData,
    filterParams,
  });
  const { formatMessage } = useIntl();

  const options = useMemo(() => {
    const legends: { name: string; itemStyle: { color: string } }[] = [];
    const series: { name: string; type: string; data: any[] }[] = [];
    let xAxis: string[] = [];
    seriesDataKeys.map(({ text, key, type, color, valueKey }, index) => {
      const data = chartMap[key];
      if (data) {
        const seriesObj: any = {
          name: text,
          type,
          data: data.map((item) => (item?.[valueKey] ? item[valueKey] : null)),
          itemStyle: {
            color,
          },
          key,
          yAxisIndex: index,
        };

        series.push(seriesObj);
        legends.push({
          name: text,
          itemStyle: { color },
        });

        if (xAxis.length === 0 && data) {
          xAxis = data.map((item) => item.time);
        }
      }
    });
    let currentOptions = {
      tooltip: {
        position: (
          pos: [any, any],
          params: any,
          dom: any,
          rect: any,
          size: { viewSize: [any, any] },
        ) =>
          getChartPosition(pos, params, dom, rect, size, 50, 15, 'bottom', 3),
        appendToBody: false,
        confine: false,
        formatter: (params: any) => {
          let title = listTimeTitleFunc(
            params?.[0]?.axisValue,
            filterParams.date_type,
            true,
          );
          return formatChartParamsDate({
            params,
            title: title,
            listTitleFunc: (params) => {
              return formatMessage({ id: params.seriesName || NO_DATE.EMPTY });
            },
            valueFormat: (value, ele) => {
              return reviewsFormat(value);
            },
          });
        },
      },
      axisPointer: getAxisPointer((data) =>
        formatTimeXAxisText(data.value, filterParams?.date_type),
      ),
      grid: {
        top: 10,
        right: 0,
        containLabel: true,
      },
      legend: {
        data: legends,
        textStyle: {
          rich: {
            a: {
              color: '#888888',
              fontSize: 12,
            },
            space: {
              width: 2,
            },
          },
        },
        formatter: (name: string) => {
          return formatMessage({ id: name || NO_DATE.EMPTY });
        },
      },
      xAxis: {
        boundaryGap: ['20%', 0],
        data: xAxis,
        axisLabel: {
          showMaxLabel: true,
          formatter: (value: string) =>
            formatTimeXAxisText(value, filterParams?.date_type),
        },
      },
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: (value: any) => {
              return echartsContent(value);
            },
          },
        },
        {
          type: 'value',
          axisLabel: {
            formatter: (value: any) => {
              return echartsContent(value);
            },
          },
        },
      ],
      series: series,
    };

    setIntervalValue(currentOptions.series[0]?.data, currentOptions.yAxis[0]);
    setIntervalValue(currentOptions.series[1]?.data, currentOptions.yAxis[1]);

    return currentOptions;
  }, [chartMap, formatMessage, filterParams]);

  return (
    <EChartCommon
      options={options}
      height={height}
      empty={chartNoDataMap}
      optionsProps={{ type: 'line' }}
      leftTitle={formatMessage({ id: 'Metascore' })}
      rightTitle={formatMessage({ id: 'User Score' })}
    ></EChartCommon>
  );
}
